"use client";

import Link from "next/link";
import { FaEnvelope, FaInstagram, FaLinkedin } from "react-icons/fa";
import dynamic from "next/dynamic";

// Fix hydration issue by forcing client-side rendering
const Footer = dynamic(() => Promise.resolve(FooterComponent), { ssr: false });

function FooterComponent() {
  return (
    <footer className="w-full text-white py-4 mt-32 mb-16">
      <div className="container mx-auto flex justify-center space-x-8">
        <div className="flex items-center space-x-2">
          <FaEnvelope className="text-lg" />
          <a
            href="mailto:contact@adityavivekverma.com"
            className=" hover:text-gray-400"
          >
            contact@adityavivekverma.com
          </a>
        </div>

        <div className="flex items-center space-x-2">
          <FaInstagram className="text-lg" />
          <a
            href="https://instagram.com/adijpeg"
            target="_blank"
            rel="noopener noreferrer"
            className=" hover:text-gray-400"
          >
            @adijpeg
          </a>
        </div>
        <div className="flex items-center space-x-2">
          <FaLinkedin className="text-lg" />
          <a
            href="https://www.linkedin.com/in/aditya-vivek-verma-8a722a226"
            target="_blank"
            rel="noopener noreferrer"
            className=" hover:text-gray-400"
          >
            Aditya Vivek Verma
          </a>
        </div>
      </div>
      <div className="text-lg container mx-auto flex justify-center space-x-8 mt-10">
        <p>© 2025 Aditya Vivek Verma. All Rights Reserved.</p>
      </div>
      <div className="text-sm container mx-auto flex justify-center space-x-8 mt-1">
        <p>
          Developed by{" "}
          <span className="text-indigo-500">
            <Link href={"https://izzat.xyz"} target="_blank">
              izzat
            </Link>
          </span>
          .
        </p>
      </div>
    </footer>
  );
}

export default Footer;
